<template>
  <div id="navtop" v-show="showFlag">
    <a @click="toLink('/')" class="active">首页</a>
    <span class="sep">|</span>
    <a @click="toLink('/Ranking')">排行榜</a>
    <span class="sep">|</span>
    <a @click="toLink('/User')">用户中心</a>
    <span class="sep">|</span>
    <a @click="toLink('/Agency')">代理商</a>
    <span class="sep">|</span>
    <a @click="toLink('/Card')">办卡管理</a>
    <span class="sep">|</span>
    <a @click="toLink('/Loan')">贷款管理</a>
    <span class="sep">|</span>
    <a @click="toLink('/Profit')">分润查询</a>
    <span class="sep">|</span>
    <a @click="toLink('/Award')">奖励制度</a>
    <span class="sep">|</span>
    <a @click="toLink('/Promo')">推广码</a>
  </div>
</template>
<script>
import Vue from 'vue'
export default {
  name: "Navtop",
  data() {
    return {
      showFlag: false
    };
  },
  created() {
  },
  methods: {
    toLink(url) {
      this.$router.push(url);
    },
    show() {
      this.showFlag = true;
    },
    hide() {
      this.showFlag = false;
    }
  },
  components: {}
};
</script>
<style lang="stylus" scoped>
  a
    color: #b0b0b0
    cursor: pointer
    &:hover
      color: #fff
  .sep
    color: #424242
    margin: 0 0.5em
  .router-link-exact-active
    color: #fff
  .active
    color: #fff
</style>



// WEBPACK FOOTER //
// src/components/navtop/navtop.vue